import type { IDropdownChild } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import { FooterButton } from "pro-features/components/MultiCategoriesChipDown/src/MultiCategoryChipdownStyles";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { useRef } from "react";

interface IMultiSelectDropdownContainerStateless {
    selectedItems: any;
    children: IDropdownChild[];
    onItemClick: (item: { id: string }) => void;
    disabled?: boolean;
    onToggleDropdown?: (isOpen: boolean) => void;
    onFooterButtonClick?: () => unknown;
    onClickOutside?: VoidFunction;
    searchPlaceHolder?: string;
    width?: number;
}

export const MultiSelectDropdownContainerStateless: FC<IMultiSelectDropdownContainerStateless> = (props) => {
    const {
        selectedItems,
        children,
        onItemClick,
        onFooterButtonClick,
        onToggleDropdown,
        onClickOutside,
        searchPlaceHolder = translate("common.placeholder.search"),
    } = props;

    const dropdownRef = useRef(undefined);

    const onClick = (newItem: { id: string }) => {
        onItemClick(newItem);
    };

    const onApply = () => {
        onFooterButtonClick();
        dropdownRef.current?.closePopup();
    };

    const onToggle = (isOpen: boolean, isOutsideClick: boolean) => {
        onToggleDropdown?.(isOpen);
        if (!isOpen) {
            onClickOutside?.();
        }
    };

    return (
        <Dropdown
            ref={dropdownRef}
            hasSearch
            selectedIds={selectedItems}
            onClick={onClick}
            onToggle={onToggle}
            closeOnItemClick={false}
            searchPlaceHolder={searchPlaceHolder}
            {...props}
            footerComponent={() =>
                onFooterButtonClick && (
                    <FooterButton
                        onClick={onApply}
                        disabled={false}
                    >
                        {<I18n>common.apply</I18n>}
                    </FooterButton>
                )
            }
        >
            {children}
        </Dropdown>
    );
};
